import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { CardPriceAtMill } from "../component/CardPriceAtMill";
import { PriceModel } from "../model/PriceModel";

type Props = {
    page: string
    onMillPriceAccepted?: (price:PriceModel) => void
    priceSelected: PriceModel | undefined
    setPriceSelected: any
    setPickUp?: () => void
    fetchedPrices?: PriceModel[]
}

export function PagePriceMillSelected({ page, onMillPriceAccepted, setPriceSelected, setPickUp, fetchedPrices }: Props) {

    const [param] = useSearchParams()

    const price = PriceModel.buildFromParam(param, fetchedPrices)

    useEffect(() => {
        window.gtag("event", "page_view", { page_path: page });
        // eslint-disable-next-line
    }, [])

    return (
        <div style={{ position: 'absolute', zIndex: 8, bottom: 0, left: 0, right: 0, display: "flex", justifyContent: "center", pointerEvents: "none" }}>
            <div id="toto" style={{ maxWidth: "500px", flex: 1 }}>
                <CardPriceAtMill style={{ flex: "1", pointerEvents: "auto", margin: "0 10px" }}
                    onClick={() => onMillPriceAccepted?.(price)}
                    price={price}
                    close={() => setPriceSelected(undefined)} />
                    {/* {
                        setPickUp && 
                        <CardPriceAtFarm style={{ flex: "1", pointerEvents: "auto", marginTop: "10px" }} onClick={() => setPickUp()} />
                    } */}
            </div>
        </div>
    )
}